(function () {
  function initProductGallery(gallery) {
    if (!(gallery instanceof HTMLElement) || gallery.dataset.novaGalleryReady) return;

    const slides = Array.from(gallery.querySelectorAll('.nova-gallery-slide'));
    const dots = Array.from(gallery.querySelectorAll('[data-nova-gallery-dot]'));
    const dotGroups = Array.from(gallery.querySelectorAll('[data-nova-gallery-dots]'));
    const tabs = Array.from(gallery.parentElement?.querySelectorAll('[data-nova-gallery-tab]') || []);
    const tabsContainer = tabs[0]?.parentElement;
    const previous = gallery.querySelector('[data-nova-gallery-previous]');
    const next = gallery.querySelector('[data-nova-gallery-next]');
    let activeIndex = 0;
    let activeMode = 'product';
    let touchStartX = 0;
    let touchStartY = 0;

    if (!slides.length) return;

    gallery.dataset.novaGalleryReady = 'true';
    gallery.setAttribute('data-active-mode', activeMode);

    function modeSlides() {
      return slides.filter((slide) => (slide.dataset.novaGalleryMode || 'product') === activeMode);
    }

    function show(index) {
      const currentSlides = modeSlides();
      if (!currentSlides.length) return;

      activeIndex = (index + currentSlides.length) % currentSlides.length;
      slides.forEach((slide) => {
        const slideIndex = currentSlides.indexOf(slide);
        const isActive = slideIndex === activeIndex;
        const wasHidden = slide.hidden;

        slide.hidden = !isActive;
        if (!isActive) {
          slide.querySelectorAll('video').forEach((video) => video.pause());
        }
        if (isActive && wasHidden) {
          slide.classList.remove('is-entering');
          requestAnimationFrame(() => slide.classList.add('is-entering'));
        }
      });
      dots.forEach((dot) => {
        const isCurrentMode = (dot.dataset.novaGalleryMode || 'product') === activeMode;
        const dotIndex = Number.parseInt(dot.dataset.novaGalleryDot || '0', 10);
        dot.classList.toggle('is-active', isCurrentMode && dotIndex === activeIndex);
        dot.setAttribute('aria-current', isCurrentMode && dotIndex === activeIndex ? 'true' : 'false');
      });
      dotGroups.forEach((group) => {
        group.hidden = group.dataset.novaGalleryDots !== activeMode;
      });
      previous.hidden = currentSlides.length < 2;
      next.hidden = currentSlides.length < 2;
    }

    previous?.addEventListener('click', () => show(activeIndex - 1));
    next?.addEventListener('click', () => show(activeIndex + 1));
    dots.forEach((dot) => dot.addEventListener('click', () => show(Number.parseInt(dot.dataset.novaGalleryDot || '0', 10))));
    gallery.addEventListener('touchstart', (event) => {
      const touch = event.touches[0];
      if (!touch) return;
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
    }, { passive: true });
    gallery.addEventListener('touchend', (event) => {
      const touch = event.changedTouches[0];
      if (!touch) return;
      const deltaX = touch.clientX - touchStartX;
      const deltaY = touch.clientY - touchStartY;
      if (Math.abs(deltaX) < 40 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
      show(activeIndex + (deltaX < 0 ? 1 : -1));
    }, { passive: true });
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        activeMode = tab.dataset.novaGalleryTab || 'product';
        activeIndex = 0;
        gallery.setAttribute('data-active-mode', activeMode);
        tabsContainer?.setAttribute('data-active-mode', activeMode);
        tabs.forEach((item) => {
          const isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        show(0);
      });
    });
    show(0);
  }

  function initProductGalleries() {
    document.querySelectorAll('[data-nova-product-gallery]').forEach(initProductGallery);
  }

  function initMediaQuotes(awards) {
    if (!(awards instanceof HTMLElement) || awards.dataset.novaMediaQuotesReady) return;

    const triggers = Array.from(awards.querySelectorAll('[data-nova-media-quote-trigger]'));
    const contents = Array.from(awards.parentElement?.querySelectorAll('[data-nova-media-quote-content]') || []);
    if (!triggers.length || !contents.length) return;

    awards.dataset.novaMediaQuotesReady = 'true';

    function show(index) {
      triggers.forEach((trigger) => {
        const isActive = trigger.dataset.novaMediaQuoteTrigger === index;
        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      contents.forEach((content) => {
        const isActive = content.dataset.novaMediaQuoteContent === index;
        const wasHidden = content.hidden;
        content.hidden = !isActive;
        if (isActive && wasHidden) {
          content.classList.remove('is-entering');
          requestAnimationFrame(() => content.classList.add('is-entering'));
        }
      });
    }

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => show(trigger.dataset.novaMediaQuoteTrigger || '0'));
    });
  }

  function initMediaQuoteGroups() {
    document.querySelectorAll('[data-nova-media-quotes]').forEach(initMediaQuotes);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductGalleries, { once: true });
  } else {
    initProductGalleries();
    initMediaQuoteGroups();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMediaQuoteGroups, { once: true });
  }

  document.addEventListener('shopify:section:load', () => {
    initProductGalleries();
    initMediaQuoteGroups();
  });
})();
